// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2vslf","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__38-Da"};